import { Container, Text, Title } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import classes from './HeroImageRight.module.css';
import { MarketingHeroActions } from './HomeMarketingSections.jsx';

/**
 * Home page hero — consolidation-first headline with CTAs.
 */
export function HeroImageRight() {
  const { t } = useTranslation('common');

  return (
    <div className={classes.root}>
      <Container size="lg">
        <div className={classes.inner}>
          <div className={classes.content}>
            <Title order={1} className={classes.title}>
              {t('marketing.hero.title')}
            </Title>

            <Text className={classes.description} mt="lg">
              {t('marketing.hero.tagline')}
            </Text>

            <MarketingHeroActions />
          </div>
        </div>
      </Container>
    </div>
  );
}
